import { ChannelType } from '@nemuru-eng/js-api-client';

export const ChannelTypeIcons = {
  [ChannelType.APP]: 'aod',
  [ChannelType.TPV]: 'point_of_sale',
  [ChannelType.WEB]: 'language',
  [ChannelType.PHONE]: 'smartphone',
  [ChannelType.STORE]: 'storefront',
  [ChannelType.MARKETPLACE]: 'devices',
  [ChannelType.SOCIAL_MEDIA]: 'diversity_3',
};
